<template>
  <div style="display:inline-block;margin:0 10px">
    <el-button size="small" type="success" @click="showDialog">创建生产派工单</el-button>
    <el-dialog title="创建生产派工单" :visible.sync="dialogVisible" width="1150px">
      <el-form :inline="true" ref="addForm" :model="addForm">
        <el-table :data="selectList" style="width:1050px;margin-left:30px" :border="true">
          <el-table-column align="center" prop="customer_name" label="客户名称" width="150px"></el-table-column>
          <el-table-column align="center" prop="product_name" label="产品名称" width="150px"></el-table-column>
          <el-table-column align="center" prop="product_size" label="产品规格" width="150px"></el-table-column>
          <el-table-column align="center" prop="product_count" label="来料数量" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.come_count`"
                :rules="{ pattern: /^\d*$/, message: '请输入数字', trigger: 'blur' }"
              >
                <el-input size="small" v-model="addForm.productList[scope.$index].come_count"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="need_hour" label="总工时" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.need_hour`"
                :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
              >
                <el-input
                  size="small"
                  :value="addForm.productList[scope.$index].need_hour"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="supplier" label="供料厂商" width="150px">
            <template slot-scope="scope">
              <el-form-item :prop="`productList.${scope.$index}.supplier`">
                <el-select
                  placeholder="供应商名称"
                  v-model="addForm.productList[scope.$index].supplier"
                  size="small"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item,index) in $store.state.supplierList"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header" slot-scope="scope">
              <div>来料日期</div>
              <el-date-picker
                size="small"
                v-model="quickComeDate"
                type="date"
                placeholder="统一设置"
                style="width:130px"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <span style="display:hidden">{{scope.row}}</span>
            </template>
            <template slot-scope="scope">
              <el-form-item :prop="`productList.${scope.$index}.delivered_date`">
                <el-date-picker
                  size="small"
                  v-model="addForm.productList[scope.$index].come_date"
                  type="date"
                  placeholder="选择日期"
                  style="width:130px"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible=false">取消</el-button>
        <el-button size="small" :disabled="buttonDisable" type="primary" @click="addProduce">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addProduce } from '../api/index'
export default {
  props: ['selectList'],
  data () {
    return {
      dialogVisible: false,
      buttonDisable: false,
      quickComeDate: new Date().format('yyyy-MM-dd'),
      addForm: {
        productList: []
      }
    }
  },
  watch: {
    selectList: {
      handler (selectList) {
        this.addForm.productList = selectList.map(item => {
          return {
            product_id: item.id,
            come_count: '',
            come_date: new Date().format('yyyy-MM-dd'),
            supplier: '',
            need_hour: ''
          }
        })
      }
    },
    'addForm.productList': {
      handler (productList) {
        productList.forEach((item, index) => {
          let totalHour = this.selectList[index].total_hour
          if (item.come_count === '' || totalHour === '' || totalHour === null) {
            item.need_hour = ''
          } else {
            item.need_hour = (item.come_count * (totalHour * 100) / 100).toFixed(2)
          }
        })
      },
      deep: true
    },
    quickComeDate (date) {
      this.addForm.productList.forEach(item => {
        item.come_date = date
      })
    }
  },
  methods: {
    showDialog () {
      if (this.selectList.length === 0) {
        this.$message.error('请至少选择一个产品')
        return
      }
      this.dialogVisible = true
    },
    addProduce () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.buttonDisable = true
          addProduce(this.addForm).then(res => {
            this.buttonDisable = false
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.dialogVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
